import { createFeature, createReducer, on } from '@ngrx/store';
import { actions } from './contact.actions';

interface ContactState {
    submitFormSuccess: boolean | null;
    submitFormLoading: boolean;
}

const initialState: ContactState = {
    submitFormSuccess: null,
    submitFormLoading: false,
};

export const state = createFeature({
    name: 'contact',
    reducer: createReducer(
        initialState,
        on(actions.submitContactFormResponse, (state, action): ContactState => {
            return {
                ...state,
                submitFormSuccess: action.success,
                submitFormLoading: false,
            };
        }),
        on(actions.submitContactFormLoading, (state, action): ContactState => {
            return {
                ...state,
                submitFormLoading: action.loading,
            };
        }),
    ),
});
